import { Seo } from '../components/Seo';
import { Reveal } from '../components/Reveal';
import { CtaBand } from '../components/CtaBand';
import { ArrowIcon } from '../components/ArrowIcon';
import { BRAND } from '../lib/brand';
import { INSTAGRAM_TAROMANCE_URL, NAVER_MAP_TAROMANCE_URL } from '../lib/externalLinks';

export function VisitPage() {
  return (
    <div className="tm-page">
      <Seo
        title="방문 안내 | 타로맨스"
        description="타로맨스 오시는 길, 영업시간, 편의 정보. 서울 강남구 도곡로11길 10 1층, 매일 17:00–03:00."
      />

      <section className="tm-page-hero">
        <div className="tm-container">
          <Reveal>
            <p className="tm-eyebrow">Visit</p>
            <h1 className="tm-display">
              강남의 골목,
              <br />
              <em>불이 켜진 작은 바</em>
            </h1>
            <p className="tm-lede">
              바 8석과 4인 테이블 하나. 아늑한 공간인 만큼, 예약하고 오시면 가장 편안하게 머무실 수 있습니다.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="tm-section">
        <div className="tm-container">
          <div className="tm-split--even tm-split">
            <Reveal>
              <div className="tm-figure tm-figure--tall">
                <img src="/assets/taromance/store/store-bar-1810.jpg" alt="타로맨스 바 전경" loading="lazy" />
              </div>
            </Reveal>
            <Reveal delay={100}>
              <div className="tm-contact-grid" style={{ gridTemplateColumns: '1fr' }}>
                <div className="tm-contact-item">
                  <h3>Address</h3>
                  <strong>({BRAND.postalCode}) {BRAND.address}</strong>
                  <span>
                    <a className="tm-arrow-link" href={NAVER_MAP_TAROMANCE_URL} target="_blank" rel="noreferrer" style={{ marginTop: 8 }}>
                      네이버 지도로 보기
                      <ArrowIcon />
                    </a>
                  </span>
                </div>
                <div className="tm-contact-item">
                  <h3>Hours</h3>
                  <strong>{BRAND.hours.label} {BRAND.hours.time}</strong>
                  <span>매출 피크는 20시–22시. 조용한 시간을 원하시면 이른 저녁 방문을 추천합니다.</span>
                </div>
                <div className="tm-contact-item">
                  <h3>Amenities</h3>
                  <strong>{BRAND.amenities.join(' · ')}</strong>
                  <span>약 10평의 아늑한 공간으로, 동시 수용 인원은 12명 내외입니다.</span>
                </div>
                <div className="tm-contact-item">
                  <h3>Contact</h3>
                  <strong>{BRAND.phoneDisplay}</strong>
                  <span>
                    <a href={`mailto:${BRAND.email}`} style={{ textDecoration: 'underline', textUnderlineOffset: 3 }}>{BRAND.email}</a>
                    {' · '}
                    <a href={INSTAGRAM_TAROMANCE_URL} target="_blank" rel="noreferrer" style={{ textDecoration: 'underline', textUnderlineOffset: 3 }}>@taromance</a>
                  </span>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <CtaBand title="오시는 길이 낯설어도, 자리는 익숙하게." secondaryLabel="예약 안내 보기" secondaryTo="/reserve" />
    </div>
  );
}
